import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { StorageService } from '../storage.service';
import { ILanguage } from '../interface/language.interface';
import { LanguageProviderService } from './language-provider.service';
import { IStoreData } from '../interface/store-data.interface';

@Injectable({ providedIn: 'root' })
export class LanguageService {
    private languageList: ILanguage[] = [];

    constructor(
        private translate: TranslateService,
        private store: Store<{ index: IStoreData }>,
        private storage: StorageService, 
    ) {
        this.store
            .select((d: any) => d.index.languageList)
            .subscribe((list: ILanguage[]) => {
                this.languageList = list;
            });
    }

    initLanguage(): void {
        const storedCode = this.storage.get('i18n_locale') || this.translate.currentLang;
        const language = this.findLanguageByCode(storedCode) || this.getFallbackLanguage();
        this.setLanguage(language);
    }

    toggleLanguage(language?: ILanguage): void {
        const lang = language || this.getStoredOrDefaultLanguage();
        this.setLanguage(lang);
    }

    private getStoredOrDefaultLanguage(): ILanguage {
        const code = this.translate.currentLang || this.storage.get('i18n_locale');
        return this.findLanguageByCode(code) || this.getFallbackLanguage();
    }

    private findLanguageByCode(code: string | null): ILanguage | undefined {
        return this.languageList.find((l) => l.code === code);
    }

    private getFallbackLanguage(): ILanguage {
        return this.findLanguageByCode('pt') || this.languageList[0]; // default fallback
    }

    private setLanguage(language: ILanguage): void {
        this.translate.use(language.code);
        this.store.dispatch({ type: 'toggleLocale', payload: language.code });
    }
}
